import {
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from "@mui/material";
import CopyableValue from "./CopyableValue";
import { getAttributionStatusLabel } from "../constants/reportEnums";

const Field = ({ label, value, copyable = false }) => (
  <Grid item xs={12} sm={6}>
    <Typography variant="caption" color="text.secondary">
      {label}
    </Typography>
    {copyable ? (
      <CopyableValue value={value} monospace />
    ) : (
      <Typography variant="body2" sx={{ mb: 1.5, wordBreak: "break-all" }}>
        {value ?? "—"}
      </Typography>
    )}
  </Grid>
);

const formatDate = (value) =>
  value ? new Date(value).toLocaleString("fa-IR") : "—";

const AttributionDetailDialog = ({ open, onClose, data }) => (
  <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
    <DialogTitle>جزئیات رهگیری #{data?.id ?? ""}</DialogTitle>
    <DialogContent dividers>
      {data ? (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="caption" color="text.secondary">
              وضعیت
            </Typography>
            <Box sx={{ mb: 1.5 }}>
              <Chip size="small" label={getAttributionStatusLabel(data.status)} />
            </Box>
          </Grid>
          <Field label="کد معرف" value={data.referralCode} copyable />
          <Field label="نماینده / معرف" value={data.partnerDisplayName} />
          <Field label="موبایل نماینده" value={data.partnerMobile} copyable />
          <Field label="مدیر L1" value={data.parentPartnerDisplayName} />
          <Field label="موبایل مدیر L1" value={data.parentPartnerMobile} copyable />
          <Field label="شناسه نماینده" value={data.partnerId} copyable />
          <Field label="شناسه بازدیدکننده" value={data.visitorId} copyable />
          <Field label="IP" value={data.ipAddress} copyable />
          <Field label="User Agent" value={data.userAgent} />
          <Field label="Landing URL" value={data.landingUrl} />
          <Field label="UTM Source" value={data.utmSource} />
          <Field label="UTM Medium" value={data.utmMedium} />
          <Field label="UTM Campaign" value={data.utmCampaign} />
          <Field label="کانال" value={data.channel} />
          <Field label="شناسه کمپین" value={data.campaignId} copyable />
          <Field label="کاربر ثبت‌نام‌شده" value={data.registeredUserDisplayName} />
          <Field label="موبایل کاربر" value={data.registeredUserMobile} copyable />
          <Field label="شناسه کاربر" value={data.registeredUserId} copyable />
          <Field label="پروژه" value={data.relatedProjectId} copyable />
          <Field label="اولین ورود" value={formatDate(data.firstSeenAt)} />
          <Field label="آخرین ورود" value={formatDate(data.lastSeenAt)} />
          <Field label="تاریخ ثبت‌نام" value={formatDate(data.registeredAt)} />
          <Field label="تاریخ ایجاد پروژه" value={formatDate(data.projectCreatedAt)} />
          <Field label="تاریخ تبدیل" value={formatDate(data.convertedAt)} />
          <Field label="انقضا" value={formatDate(data.expiresAt)} />
        </Grid>
      ) : null}
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>بستن</Button>
    </DialogActions>
  </Dialog>
);

export default AttributionDetailDialog;
